var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.87 0C4.87 0 0 4.87 0 10.87C0 16.87 4.87 21.74 10.87 21.74C16.87 21.74 21.74 16.87 21.74 10.87C21.74 4.87 16.87 0 10.87 0Z",
    fill: "#74B743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3001 8.02004C12.8501 8.02004 12.4301 7.75004 12.2801 7.33004C12.0801 6.76004 11.6001 6.54004 10.9501 6.54004C9.85008 6.54004 9.50008 7.24004 9.50008 8.12004V9.12004C9.50008 10.71 11.3101 10.87 12.0101 12.51C12.3101 13.21 11.7501 13.99 10.9901 13.99C10.5501 13.99 10.1301 13.74 9.99008 13.32C9.50008 11.84 7.33008 12.1 7.33008 9.06004V8.10004C7.33008 5.52004 8.97008 4.54004 10.9701 4.54004C12.4001 4.56004 13.8001 5.01004 14.3301 6.54004C14.5901 7.26004 14.0601 8.02004 13.3001 8.02004ZM12.4101 16C12.4101 17.61 9.94008 17.59 9.94008 16C9.94008 14.39 12.4101 14.37 12.4101 16Z",
    fill: "#74B743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/questions.a8181fcd164e38faa8258f2a8253ec86.svg";
export { ForwardRef as ReactComponent };